import { WalletBalanceDTO } from "@gymflow/types";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";
import { queryClient } from "../../QueryClient";
import { tokenPagination } from "../../tokenPagination";

const keys = {
  all: () => ["staffApiWallet"] as const,
  perUser: (memberId: unknown) => [...keys.all(), "perUser", memberId] as const,

  list: (memberId: unknown) => [...keys.perUser(memberId), "list"] as const,

  listHistory: (memberId: string | undefined, params?: object) =>
    [...keys.perUser(memberId), "listHistory", params] as const,
};

export const staffApiWallet = {
  keys,
  queries: {
    list: (userMemberId: string | undefined) =>
      queryOptions({
        queryKey: keys.list(userMemberId),
        queryFn: async () => {
          return (
            await api.get<WalletBalanceDTO>(`wallet-balance/${userMemberId}`)
          ).data;
        },
        enabled: !!userMemberId,
      }),
  },
  infiniteQueries: {
    listHistory: (
      userMemberId: string | undefined,
      params: {
        limit?: number;
        nextPageToken?: string;
        walletTransactionTypes?: string[];
        dateFrom: string | null;
        dateTo: string | null;
      },
    ) =>
      infiniteQueryOptions({
        queryKey: keys.listHistory(userMemberId, params),
        queryFn: async ({ pageParam }) =>
          (
            await api.get(
              `/user-member/${userMemberId}/wallet-balance/history`,
              {
                params: {
                  ...params,
                  nextPageToken: pageParam,
                },
              },
            )
          ).data,
        ...tokenPagination,
      }),
  },
   mutations: {
      redeem: (userMemberId: string | undefined) => ({
        mutationFn: async ({ voucherCode }: { voucherCode: string }) => {
          return (
            await api.put<{ voucherCode: string }>(
              `/wallet-balance/${userMemberId}/voucher-redeem/${voucherCode}`,
            )
          ).data;
        },
        onSettled: async () =>
          await queryClient.invalidateQueries({
            queryKey: keys.perUser(userMemberId),
          }),
      }),
    },
};
